import { gql } from '@apollo/client';
import {
  areaFragment,
  regionFragment,
  stateTerritoryFragment,
  suburbFragment,
  sysFragment
} from '@src/graphql/fragments';

export const communitiesByStateQuery = gql`
  query communitiesByState($preview: Boolean) {
    states: stateCollection(limit: 5, preview: $preview) {
      items {
        ...stateTerritory
      }
    }
  }

  ${sysFragment}
  ${stateTerritoryFragment}
  ${regionFragment}
  ${areaFragment}
  ${suburbFragment}
`;
